import { inject, Injectable, OnDestroy } from '@angular/core';
import { IResponseMetaResult, IResponseMetaResultRedirect, RequestService } from '@df/api/request/request.service';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RespectRedirectsService implements OnDestroy {
    private requestService = inject(RequestService);

    protected subscription = new Subscription();

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    appInitialize() {
        this.subscription.add(
            this.requestService.subscribe<IResponseMetaResult>(response => {
                if (response?.result) {
                    this.onResult(response.result);
                }
            })
        );
    }

    onResult(result: IResponseMetaResult | any): void {
        if (result) {
            const redirect: IResponseMetaResultRedirect | undefined = result.post_redirect;
            // if 'post_redirect' param is returned then send post request
            if (redirect) {
                this.requestService.postLikeForm(redirect.action, redirect.data);
                result.successMessage = 'Redirecting...';
            } else if (result.external_redirect) {
                // if 'external_redirect' param is returned then redirect to that page
                window.location.href = result.external_redirect;
                result.successMessage = 'Redirecting...';
            }
        }
    }
}
